type SharedMiniAppPath = "booking" | "proposal";

type SharedMiniAppUrlParams = {
    hostingOrigin: string;
    path: SharedMiniAppPath;
    tenant: string;
    locale: string;
    id: string;
    parentOrigin: string;
    hash?: string;
};

export function sharedMiniAppUrl({
    hostingOrigin,
    path,
    tenant,
    locale,
    id,
    parentOrigin,
    hash,
}: SharedMiniAppUrlParams): string | null {
    if (!hostingOrigin) {
        return null;
    }

    try {
        const url = new URL(`/${path}`, hostingOrigin);
        url.searchParams.set("tenant", tenant);
        url.searchParams.set("locale", locale);
        url.searchParams.set("id", id);
        url.searchParams.set("parentOrigin", parentOrigin);
        // parentOrigin is a generic embed parameter, so agent preview needs its own
        // discriminant to avoid claiming any embedded member page.
        url.searchParams.set("mode", "agent-preview");
        url.hash = hash ?? "";
        return url.toString();
    } catch {
        return null;
    }
}
